
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Bank } from "@/models/base";
import { BankService } from "@/services/bank-service";
import { BrowseService } from "@/services/browse-service";
import Vue from "vue";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import { HumanFilter } from "@/utils/human-filter";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { BookYearService } from "@/services/book-year-service";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";

export default Vue.extend({
	data() {
		return {
			selectedBookYear: `${BookYearService.selectedBookYear}`,
		};
	},
	props: {
		contactId: {
			type: Number,
			default: 0
		},
		bookYearSelect: {
			type: Boolean,
			default: false
		},
		clearViewSettingsFilters: Boolean,
		allowViewButton: Boolean
	},
	computed: {
		extraFilters():HumanFilter[]{
			let result:HumanFilter[] = [];
			if (this.contactId != 0){
				let filter = new HumanFilter();
				filter.Field = "this.ContactID";
				filter.Operator = "=";
				filter.Values = [`${this.contactId}`];
				result.push(filter);
			}
			return result;
		},
		dataSource(): IBrowseBaseDataSource<Bank> {
			return {
				getSettings: () => BrowseService.getBrowse(8),
				getElements: (params)=>BankService.get(params, this.extraFilters),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return BankService.getTotals(view);
				},
				browseName: "Banks",
				modelName: "Bank",
			};
		},
	},
	methods: {
		onBookYearChange(bookyear:string) {
			this.selectedBookYear = bookyear;
			let browse = this.$refs.browse as any;
			if (!browse) return;
			browse.refresh();
		}
	},
	components: {
		AppSearchBrowse,
		AppSelectBookYear
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
